module.exports = __webpack_public_path__ + "static/media/service-rights.307060a8.png";